import { createDeck, shuffleDeck } from '../poker/cards.js';
import { NUM_DECKS, PENETRATION_MIN_CARDS } from './rules.js';

/**
 * @typedef {{ cards: import('../poker/cards.js').Card[] }} ShoeState
 */

/**
 * @param {() => number} rng
 * @returns {ShoeState}
 */
export function createShoe(rng = Math.random) {
  let cards = [];
  for (let d = 0; d < NUM_DECKS; d += 1) {
    cards = cards.concat(createDeck());
  }
  return { cards: shuffleDeck(cards, rng) };
}

/**
 * @param {ShoeState} shoe
 * @param {() => number} rng
 */
export function ensureShoeReady(shoe, rng = Math.random) {
  if (!shoe.cards || shoe.cards.length < PENETRATION_MIN_CARDS) {
    const next = createShoe(rng);
    shoe.cards = next.cards;
  }
}

/**
 * @param {ShoeState} shoe
 * @returns {import('../poker/cards.js').Card|null}
 */
export function drawFromShoe(shoe) {
  const c = shoe.cards.shift();
  return c || null;
}
